import { FC } from 'react';

import {
  ButtonsWrapper,
  CancelButton,
  ModalTextWrapper,
  ModalTitle,
  ModalWrapper
} from '@anm/components/stream/destination_management/ConnectToFacebookModal/Wrapper';
import { DestinationTypes } from '../types';
import { StreamingNetwork } from 'types/stream';

type ErrorNoDestinationsModalProps = {
  type: DestinationTypes;
  onModalClose: () => void;
  network?: StreamingNetwork;
  isAdminOnlyGroups?: boolean;
};

const ErrorNoDestinationsModal: FC<ErrorNoDestinationsModalProps> = ({
  onModalClose,
  type,
  network = 'FACEBOOK',
  isAdminOnlyGroups = false
}) => {
  const lowercaseNetwork = network.toLowerCase();

  return (
    <ModalWrapper {...{ onModalClose }}>
      <ModalTitle title={`Can't add ${lowercaseNetwork} ${type}`} />
      <ModalTextWrapper>
        Looks like there are no {lowercaseNetwork} {type}s {isAdminOnlyGroups ? 'with admin rights' : ''} connected to
        your account. Please try to {type === 'page' ? 'create one' : 'join one'} and try again.
      </ModalTextWrapper>
      <ButtonsWrapper>
        <CancelButton variant="white-blue-border-share" size="medium" onClick={onModalClose}>
          Close
        </CancelButton>
      </ButtonsWrapper>
    </ModalWrapper>
  );
};

export default ErrorNoDestinationsModal;
